<script setup lang="ts">
defineProps<{
    name: string;     // e.g. "admin-home", "facebook"
}>();
</script>

<template>
    <span :class="`dashicons dashicons-${name} ei-icon`" aria-hidden="true" />
</template>

<style scoped>
.ei-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    width: 1em;
    height: 1em;
    font-size: 1em;
    line-height: 1;
}
</style>
